export const mutation_validateCodiceFiscale = `
mutation ValidateCodiceFiscale($codiceFiscale: String!) {
    validateCodiceFiscale(codiceFiscale: $codiceFiscale) {
        isValid
        value
        type
    }
}`;
export const mutation_validatePartitaIva = `
mutation ValidatePartitaIva($partitaIva: String!) {
    validatePartitaIva(partitaIva: $partitaIva) {
        isValid
        value
        type
    }
}`;